module.exports = __webpack_public_path__ + "static/media/rs.076daca0.png";